const UploadDocuments = ({ computationDocs, allfieldsReadonly, handleFileChange, current_page }) => {
    return <>
        <div className="lead-form-heading">
            <h3><b>Upload Documents</b></h3>
        </div>
        <div className="acco-doc-list">
            <ul>
                <li>
                    <div className='doc-count-txt'>
                        Computation Documents
                        <span className="lead-doc-count">{computationDocs?.length} / {5}</span>
                    </div>
                    <div className="more-file-upload doc-upload-btn">
                        <input aria-label="img upload" type="file" name="" accept=".pdf,image/*" disabled={!["computation_generated"].includes(current_page) || allfieldsReadonly || computationDocs?.length >= 5} onChange={e => handleFileChange(e)} required={false} />
                        <button aria-label="img upload btn" type="button" className="btn-line" disabled={!["computation_generated"].includes(current_page) || allfieldsReadonly || computationDocs?.length >= 5}>
                            <i className='ic-upload'></i> Upload
                        </button>
                    </div>
                </li>
            </ul>
        </div>
    </>;
};


export default UploadDocuments;
